(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/calendar.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/calendar.js');

'use strict';

svs.game_results.views.Calendar = Marionette.View.extend({
  modelEvents: {
    'change:startDate': 'updateCalendarTitle'
  },
  template(data) {
    return svs.game_results.templates.calendar(data);
  },
  initialize() {
    this.enabledDates = [];
  },
  onAttach() {
    const self = this;
    this.calendar = new svs.components.Calendar({
      el: '.js-game-results-calendar',
      isDropDown: true,
      lazyLoad: true,
      dotted: true,
      datePickerOptions: {
        max: new Date(),
        onRender() {
          self.renderSausage();
        },
        onSet(context) {
          self.datePicker.$root.find('.js-previous').addClass('disabled');
          self.updateCalendar(context);
        },
        onStart() {
          self.datePicker = this;
          const enabledDates = self.getEnabledDates();
          const enabledDatesLength = enabledDates.length;
          const startDate = self.model.get('startDate');
          if (enabledDatesLength > 0 && !startDate && dateFns.isBefore(new Date(enabledDates[enabledDatesLength - 1]), new Date())) {
            self.datePicker.set({
              select: enabledDates[enabledDatesLength - 1],
              highlight: enabledDates[enabledDatesLength - 1]
            }, {
              muted: true
            });
          } else if (startDate) {
            self.datePicker.set({
              select: startDate,
              highlight: startDate
            }, {
              muted: true
            });
          }
        },
        onOpen() {
          self.datePicker.$root.find('.js-previous').removeClass('disabled');
        },
        disable: [true].concat(self.enabledDates)
      }
    });
    this.datePicker = this.calendar.datePickerInstance;
    this.listenTo(this.model, 'resultDates:fetched', () => {
      if (self.datePicker && self.datePicker.$root) {
        self.datePicker.$root.find('.js-previous').removeClass('disabled');
      }
    });
    this.updateCalendarTitle();
  },
  updateCalendarTitle() {
    if (this.model.get('startDate')) {
      const calenderDate = dateFns.format(new Date(this.model.get('startDate')), 'eeee, d/M (\'v\'w)', {
        locale: dateFns.locales.sv
      });
      const newTitle = calenderDate.charAt(0).toUpperCase() + calenderDate.substring(1);
      this.calendar.updateTitle(newTitle);
    }
  },
  onDomRefresh() {
    const self = this;
    const previousMonth = dateFns.subMonths(new Date(), 1);
    const currentProduct = this.model.get('product');
    let getFutureDates = false;
    switch (currentProduct) {
      case 'europatipset':
      case 'stryktipset':
      case 'challenge':
      case 'topptipset':
      case 'powerplay':
      case 'bomben':
      case 'maltipset':
        getFutureDates = true;
        break;
      default:
    }

    this.model.getCalendarDates(new Date().getFullYear(), new Date().getMonth(), gotDates => {
      if (gotDates) {
        this.model.getCalendarDates(dateFns.getYear(previousMonth), dateFns.getMonth(previousMonth), () => {
          const enabledDates = this.getEnabledDates();
          this.calendar.datePickerOptions.disable = [true].concat(enabledDates);
          if (getFutureDates) {
            const lastEnabledDate = enabledDates[enabledDates.length - 1];
            this.calendar.datePickerOptions.max = new Date(lastEnabledDate[0], lastEnabledDate[1], lastEnabledDate[2]);
          } else {
            const lastRound = svs.game_results.data[this.model.get('productName')];
            let lastRoundDate;
            if (currentProduct == 'topptipset' && lastRound.responses && lastRound.responses[0] && lastRound.responses[0].results) {
              const lastRoundResult = lastRound.responses[0].results[0];
              lastRoundDate = new Date(lastRoundResult.regCloseTime);
            } else {
              lastRoundDate = lastRound && lastRound.result ? new Date(lastRound.result.regCloseTime) : '';
            }
            if (lastRound && lastRoundDate && !dateFns.isSameDay(new Date(lastRoundDate), new Date())) {
              const today = new Date();
              const yesterday = today;
              yesterday.setDate(today.getDate() - 1);
              this.calendar.datePickerOptions.max = yesterday;
            }
          }

        });
      } else {
        self.model.getCalendarDates(dateFns.getYear(previousMonth), dateFns.getMonth(previousMonth), () => {
          const twoMonthsBack = dateFns.subMonths(new Date(), 2);
          self.model.getCalendarDates(dateFns.getYear(twoMonthsBack), dateFns.getMonth(twoMonthsBack), () => {
            self.calendar.datePickerOptions.disable = [true].concat(self.getEnabledDates());
          });
        });
      }
    });
  },
  getEnabledDates() {
    if (this.model.get('resultDates')) {
      const enabledDates = {};
      this.model.get('resultDates').forEach(currentValue => {
        if (currentValue && currentValue.date) {
          if (currentValue.openDate && currentValue.closeDate) {
            let openDate = new Date(currentValue.openDate);
            const closeDate = new Date(currentValue.closeDate);
            while (dateFns.isBefore(openDate, closeDate) || dateFns.isSameDay(openDate, closeDate)) {
              enabledDates[dateFns.format(openDate, 'yyyy-MM-dd', {
                locale: dateFns.locales.sv
              })] = true;
              openDate = dateFns.addDays(openDate, 1);
            }
          } else {
            enabledDates[dateFns.format(new Date(currentValue.date), 'yyyy-MM-dd', {
              locale: dateFns.locales.sv
            })] = true;
          }
        }
      });
      return Object.keys(enabledDates).map(enabledDate => {
        const date = new Date(enabledDate);
        return [date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()];
      });
    }
    return [];
  },
  renderSausage() {
    const $days = $('.picker__day--infocus').not('.picker__day--disabled');
    const firstDay = new Date($($days[0]).data('pick'));
    if (dateFns.isValid(firstDay)) {
      const yearMonthString = dateFns.format(firstDay, 'yyyy-MM', {
        locale: dateFns.locales.sv
      });
      const resultDates = svs.game_results.models.calendar.get('resultDates').filter(resultDate => resultDate.openDate && resultDate.closeDate);
      const filteredDates = resultDates.filter(resultDate => resultDate.openDate.indexOf(yearMonthString) > -1 || resultDate.closeDate.indexOf(yearMonthString) > -1);
      let openDate;
      let closeDate;
      const eachFunc = (index, pickerDay) => {
        const $pickerDay = $(pickerDay);
        const pickerDate = new Date($pickerDay.data('pick'));
        if (dateFns.isSameDay(openDate, pickerDate)) {
          $pickerDay.addClass('sausage-start');
        } else if (dateFns.isSameDay(closeDate, pickerDate)) {
          $pickerDay.addClass('sausage-end');
        } else if (dateFns.isBefore(dateFns.endOfDay(openDate), dateFns.endOfDay(pickerDate)) && dateFns.isAfter(dateFns.endOfDay(closeDate), dateFns.endOfDay(pickerDate))) {
          $pickerDay.addClass('sausage-middle');
        }
      };
      for (let i = 0; i < filteredDates.length; i++) {
        openDate = new Date(filteredDates[i].openDate);
        closeDate = new Date(filteredDates[i].closeDate);
        $days.each(eachFunc);
      }
    }
  },
  updateCalendar(context) {
    const pickerInputVal = this.calendar.getInputValue();
    const view = this.datePicker.get('view');
    if (context && context.highlight) {
      if (view.pick < context.highlight.pick) {
        const previousMonth = dateFns.subMonths(new Date(view.pick), 1);
        this.model.getCalendarDates(dateFns.getYear(previousMonth), dateFns.getMonth(previousMonth), () => {
          this.newResultDates();
        });
      } else {
        this.datePicker.$root.find('.js-previous').removeClass('disabled');
      }

    } else if (pickerInputVal.length > 0 && pickerInputVal.split('-')[1] !== this.datePicker.get('view').month) {
      const drawNumbers = [];
      let hasDrawNumbers = false;
      this.model.get('resultDates').forEach(resultDate => {
        if (dateFns.format(new Date(resultDate.date), 'yyyy-MM-dd', {
          locale: dateFns.locales.sv
        }) === pickerInputVal || resultDate.openDate && resultDate.closeDate &&

        dateFns.isAfter(new Date(pickerInputVal), dateFns.subDays(new Date(resultDate.openDate), 1)) && dateFns.isBefore(new Date(pickerInputVal), dateFns.addDays(new Date(resultDate.closeDate), 1))) {
          if (resultDate.drawNumber) {
            drawNumbers.push({
              product: resultDate.product,
              drawNumber: resultDate.drawNumber,
              date: resultDate.date.split('T')[0]
            });
            hasDrawNumbers = true;
          } else {
            drawNumbers.push({
              product: resultDate.product,
              drawNumber: resultDate.date.split('T')[0]
            });
            hasDrawNumbers = true;
          }
        }
      });
      if (hasDrawNumbers) {
        this.model.set('drawNumber', drawNumbers);
        this.model.set('startDate', drawNumbers[0].date);
        this.model.set('date', pickerInputVal, {
          silent: this.model.changed.drawNumber
        });
        let targetUrl = "/".concat(this.model.get('product'), "/");
        for (let i = 0; i < drawNumbers.length; i++) {
          if (i !== drawNumbers.length - 1) {
            targetUrl += "".concat(drawNumbers[i].drawNumber, "-");
          } else {
            targetUrl += drawNumbers[i].drawNumber;
          }
        }
        targetUrl = "".concat(targetUrl, "/").concat(pickerInputVal);
        svs.game_results.router.navigate(targetUrl, {
          trigger: false
        });
        return true;
      }
      return false;
    }
  },
  newResultDates() {
    const enabledDates = this.getEnabledDates();
    const actualMonth = this.datePicker.get('view').month;
    const actualYear = this.datePicker.get('view').year;
    const filteredDates = enabledDates.filter(date => date[0] === actualYear && date[1] === actualMonth);
    const chosenYear = dateFns.getYear(new Date(this.datePicker.get('view').obj));
    const firstDate = _.first(filteredDates);
    const chosenYearExists = filteredDates.length < 1 ? false : _.isEqual(dateFns.getYear(new Date("".concat(firstDate[0], "-01-01"))), chosenYear);

    if (filteredDates.length > 0 && chosenYearExists) {
      this.datePicker.set('disable', filteredDates, {
        muted: true,
        defaultValue: true
      });
    }
  }
});

 })(window);